import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { IUserCredentials } from '../services/pre-login.model';
import { LoggedInUserDeails } from '../services/login.model';


@Injectable({
  providedIn: 'root'
})
export class SsoSaveAttemptedPaswordService {

  constructor(private httpclient: HttpClient, private httpHeaderService: HttpHeadersService){}

  post(userCredentials: IUserCredentials): Observable <LoggedInUserDeails> {
    const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
    const result = this.httpclient.post(environment.servicePath + '/login/save_attempted_sso_login_info', userCredentials, { headers});
    return result as Observable<LoggedInUserDeails>;

  }
}
